import React, { useState } from 'react';
import { Dropdown as Select, Menu } from 'antd';
import { GoChevronDown } from 'react-icons/go';
import Text from 'ReusableComponents/Text';
import './style.css';
import { DESIGN_CONFIG, STRING_CONFIG } from 'utils';

function Dropdown({ setUser }) {
  const [focus, setFocus] = useState(false);

  const [selectedLabel, setSelectedLabel] = useState(null);

  const handleDropdown = () => setFocus(!focus);

  const genderMap = {
    Female: 2,
    Male: 1,
    Other: 0,
  };

  const handleMenuClick = (label) => {
    setSelectedLabel(label);
    const genderValue = genderMap[label];

    setUser((prevUser) => ({
      ...prevUser,
      gender: genderValue,
    }));
  };

  const items = [
    {
      label: (
        <Text
          fontSize='.875rem'
          fontWeight={400}
          margin={0}
          textColor={DESIGN_CONFIG.color.text.text500}
        >
          {STRING_CONFIG.inPage.common.txtMale}
        </Text>
      ),
      key: '1',
      onClick: () => handleMenuClick('Male'),
    },
    {
      label: (
        <Text
          fontSize='.875rem'
          fontWeight={400}
          margin={0}
          textColor={DESIGN_CONFIG.color.text.text500}
        >
          {STRING_CONFIG.inPage.common.txtFemale}
        </Text>
      ),
      key: '2',
      onClick: () => handleMenuClick('Female'),
    },
    {
      label: (
        <Text
          fontSize='.875rem'
          fontWeight={400}
          margin={0}
          textColor={DESIGN_CONFIG.color.text.text500}
        >
          {STRING_CONFIG.inPage.common.txtOther}
        </Text>
      ),
      key: '3',
      onClick: () => handleMenuClick('Other'),
    },
  ];

  const menu = (
    <Menu>
      {items.map((item) => (
        <Menu.Item key={item.key} onClick={item.onClick}>
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Select
      onVisibleChange={() => {
        setFocus(!focus);
      }}
      overlay={menu}
      trigger={['click']}
    >
      <div
        className='gender'
        onClick={handleDropdown}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleDropdown();
          }
        }}
        role='button'
        tabIndex={0}
        style={{
          border: `1px solid ${focus ? DESIGN_CONFIG.color.primary.primaryMain : DESIGN_CONFIG.color.neutral.neutral100}`,
        }}
      >
        <Text
          fontSize={DESIGN_CONFIG.typography.common.webLabel.fontSize}
          fontWeight={DESIGN_CONFIG.typography.common.webLabel.fontWeight}
          margin={0}
          textColor={
            selectedLabel
              ? DESIGN_CONFIG.color.text.text200
              : DESIGN_CONFIG.color.text.text100
          }
        >
          {selectedLabel || STRING_CONFIG.inPage.userProfile.lblGender}
        </Text>
        <GoChevronDown size={20} />
      </div>
    </Select>
  );
}

export default Dropdown;
